import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../cn';
const VARIANT_CLASSES = {
    primary: 'bg-[var(--accent)] text-white hover:brightness-95 active:brightness-90 disabled:bg-slate-300 disabled:text-slate-500',
    secondary: 'bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 disabled:bg-slate-100 disabled:text-slate-400 disabled:border-slate-200',
    ghost: 'bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-700 disabled:text-slate-300',
    danger: 'bg-[var(--danger)] text-white hover:brightness-95 active:brightness-90 disabled:bg-slate-300 disabled:text-slate-500',
};
// ⚠️ Hauteurs en VALEURS ARBITRAIRES ([28px]…) — le preset tailwind du
// package mappe l'échelle numérique en px 1:1 (h-8 = 8px !), ce qui
// écrasait tous les boutons en crêpes (bug « vilain header » vu par Ben
// 17/07, computed height mesurée à 8px). Ne jamais revenir à h-7/h-8/h-10.
const SIZE_CLASSES = {
    sm: 'h-[28px] px-[10px] text-[12px] gap-1',
    md: 'h-[34px] px-[13px] text-[13px] gap-[6px]',
    lg: 'h-[40px] px-[16px] text-[14px] gap-2',
};
const ICON_ONLY_SIZE = {
    sm: 'h-[28px] w-[28px] p-0',
    md: 'h-[34px] w-[34px] p-0',
    lg: 'h-[40px] w-[40px] p-0',
};
/**
 * Button — primary interactive control.
 *
 * Replaces the mockup classes `.btn`, `.btn-primary`, `.btn-secondary`,
 * `.btn-ghost`, `.btn-danger`, `.btn-sm`.
 *
 * @example
 *   <Button variant="primary" iconLeft={<Plus size={14} />}>Nouvelle commande</Button>
 *   <Button variant="secondary" size="sm">Filtrer</Button>
 */
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', iconLeft, iconRight, iconOnly = false, loading = false, disabled, className, children, type = 'button', ...rest }, ref) {
    return (_jsxs("button", { ref: ref, type: type, disabled: disabled || loading, "aria-busy": loading || undefined, className: cn('inline-flex items-center justify-center rounded-[7px] font-medium', 'transition-colors duration-100 ease-out', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[var(--accent)]', 'disabled:cursor-not-allowed', VARIANT_CLASSES[variant], iconOnly ? ICON_ONLY_SIZE[size] : SIZE_CLASSES[size], loading && 'opacity-70', className), ...rest, children: [iconLeft ? _jsx("span", { className: "inline-flex shrink-0", children: iconLeft }) : null, iconOnly ? (
            // In iconOnly mode, children IS the icon when no iconLeft was provided
            !iconLeft && children ? (_jsx("span", { className: "inline-flex shrink-0", children: children })) : null) : children ? (_jsx("span", { className: "truncate", children: children })) : null, iconRight ? _jsx("span", { className: "inline-flex shrink-0", children: iconRight }) : null] }));
});
//# sourceMappingURL=Button.js.map